import {
  isPending,
  getCareersSuccess,
  getSingleCareerSuccess,
  createCareerSuccess,
  updateCareerSuccess,
  deleteCareerSuccess,
  careerFail,
} from "./CareerSlice";
import careerAPI from "../../apis/careerApi";

// Helpers
const pickArray = (res) =>
  Array.isArray(res)
    ? res
    : Array.isArray(res?.data)
    ? res.data
    : Array.isArray(res?.data?.careers)
    ? res.data.careers
    : [];

const pickObject = (res) =>
  res && res._id
    ? res
    : res?.data && res?.data._id
    ? res.data
    : res?.data?.career && res.data.career._id
    ? res.data.career
    : null;

// ✅ Create Career
export const createCareerAction = (careerData) => async (dispatch) => {
  dispatch(isPending());
  try {
    const res = await careerAPI.createNewCareer(careerData);
    const obj = pickObject(res);
    if (obj) {
      dispatch(createCareerSuccess(obj));
      return obj;
    }
    return dispatch(careerFail(res));
  } catch (error) {
    dispatch(careerFail(error));
    return error;
  }
};

// ✅ Get all careers
export const fetchCareersAction = () => async (dispatch) => {
  dispatch(isPending());
  try {
    const res = await careerAPI.fetchCareers();
    const arr = pickArray(res);
    if (arr.length >= 0) {
      dispatch(getCareersSuccess(arr));
      return arr;
    }
    return dispatch(careerFail(res));
  } catch (error) {
    dispatch(careerFail(error));
    return error;
  }
};

// ✅ Get single career
export const fetchSingleCareerAction = (_id) => async (dispatch) => {
  dispatch(isPending());
  try {
    const res = await careerAPI.fetchCareers(_id);
    const obj = pickObject(res);
    if (obj) {
      dispatch(getSingleCareerSuccess(obj));
      return obj;
    }
    return dispatch(careerFail(res));
  } catch (error) {
    dispatch(careerFail(error));
    return error;
  }
};

// ✅ Update career
export const updateCareerAction = (_id, careerData) => async (dispatch) => {
  dispatch(isPending());
  try {
    const res = await careerAPI.updateCareer(_id, careerData);
    const obj = pickObject(res);
    if (obj) {
      dispatch(updateCareerSuccess(obj));
      return obj;
    }
    return dispatch(careerFail(res));
  } catch (error) {
    dispatch(careerFail(error));
    return error;
  }
};

// ✅ Delete career
export const deleteCareerAction = (_id) => async (dispatch) => {
  dispatch(isPending());
  try {
    await careerAPI.deleteCareer(_id);
    dispatch(deleteCareerSuccess(_id));
    return _id;
  } catch (error) {
    dispatch(careerFail(error));
    return error;
  }
};
